import { render, staticRenderFns } from "./setPrice.vue?vue&type=template&id=3123d9a0&scoped=true&"
import script from "./setPrice.vue?vue&type=script&lang=js&"
export * from "./setPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3123d9a0",
  null
  
)

export default component.exports